import {callSSE} from "../services/sseService";

export const controlPanelAPI = {
    enhance_job_description: ({
        body, 
        onChunk, 
        onOpen, 
        onClose, 
        onError
    }) => {
        const controller = new AbortController();
        void callSSE({
            endpoint: 'enhance_job_description',
            body: body,
            signal: controller.signal,
            onMessage: onChunk,
            onOpen,
            onClose,
            onError
        }).catch((e) => onError?.(e));
        return () => controller.abort();
    },
}